/**
 * Languages whose text is written right-to-left. Matched by name (case-
 * insensitive) against `task.language` — there is no script/BCP-47 code on
 * the task object, only a free-text language name from batch data, so a
 * hardcoded allowlist is the simplest reliable signal for now.
 */
const RTL_LANGUAGES = new Set([
  'urdu',
  'kashmiri',
  'sindhi',
  'pashto',
  'balochi',
  'arabic',
  'persian',
  'farsi',
  'dari',
]);

export function isRtlLanguage(language) {
  if (typeof language !== 'string') return false;
  return RTL_LANGUAGES.has(language.trim().toLowerCase());
}
